import { useEffect, useState } from 'react';
import { getTeamMembersForSpecificRoles } from '../api';
import { TeamMember } from '../interfaces';

export type UseTeamMembers = () => {
  teamMembers: TeamMember[];
  teamMembersAreLoading: boolean;
  teamMembersFailedLoading: boolean;
  teamMembersLoadingError: Error | null;
};

export const useTeamMembers: UseTeamMembers = () => {
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([]);
  const [teamMembersAreLoading, setTeamMembersAreLoading] =
    useState<ReturnType<UseTeamMembers>['teamMembersAreLoading']>(false);
  const [teamMembersFailedLoading, setTeamMembersFailedLoading] =
    useState<ReturnType<UseTeamMembers>['teamMembersFailedLoading']>(false);
  const [teamMembersLoadingError, setTeamMembersLoadingError] =
    useState<ReturnType<UseTeamMembers>['teamMembersLoadingError']>(null);

  useEffect(() => {
    // Fetch team members
    (async () => {
      try {
        setTeamMembersAreLoading(true);
        setTeamMembers(await getTeamMembersForSpecificRoles());
        setTeamMembersAreLoading(false);
      } catch (error) {
        setTeamMembersFailedLoading(true);
        setTeamMembersLoadingError(error as Error);
        setTeamMembersAreLoading(false);
      }
    })();
  }, []);

  return {
    teamMembers,
    teamMembersAreLoading,
    teamMembersFailedLoading,
    teamMembersLoadingError,
  };
};
